import getConfig from 'next/config'

const {
  publicRuntimeConfig: { optimizelyId },
} = getConfig()

export const OptimizelyWebScripts = () => {
  return (
    <>
      {optimizelyId && (
        <script src={`https://cdn.optimizely.com/js/${optimizelyId}.js`} />
      )}
    </>
  )
}
